import { useEffect } from 'react';

const useOverflowScrolling = (query: string): void => {
  useEffect(() => {
    const style = `<style id="overflowScrollDisable">
      ${query} {
        -webkit-overflow-scrolling: auto;
      }
    </style>`;
    document.head.insertAdjacentHTML('beforeend', style);

    return () => {
      document.getElementById('overflowScrollDisable')?.remove();
    };
  }, []);
};

export { useOverflowScrolling };
